import { Pipe, PipeTransform } from '@angular/core';

import { PipesHelperInterface } from '@core/interfaces';

@Pipe({
  name: 'search',
  standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(endpoints: PipesHelperInterface.ISearchPipeData[], search = ''): PipesHelperInterface.ISearchPipeData[] {
    if (!search.trim()) {
      return endpoints;
    }
    return endpoints.filter(endpoint => {
      return (endpoint.name?.toLowerCase().includes(search.toLowerCase()) || endpoint.id.toString().toLowerCase().includes(search.toLowerCase()));
    });
  }
}
